<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Order Cetak
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="print()">
            <i class="fa fa-print"></i> Print
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>

          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
        <b-row>
          <b-col lg="11" xl="10">
            <b-input-group>
                <b-input-group-prepend>
                  <span class="pt-2">Tanggal Cetak</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="model.tgl1"
                  type="date"
                  :state="!$v.model.tgl1.$error"
                ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
                <b-form-input
                  v-model="model.tgl2"
                  type="date"
                ></b-form-input>
                <b-input-group-prepend>
                  <span class="pl-3 pt-2">Percetakan</span>
                </b-input-group-prepend>
                  <b-form-select
                    v-model="model.percetakan_id"
                    :plain="true"
                    :options="percetakans"
                  ></b-form-select>
                <b-input-group-append class="ml-2">
                  <button class="btn btn-success mr-1 ml-4" @click.stop="process()">
                    <i class="fa fa-play"></i> Process
                  </button>
                </b-input-group-append>
          </b-input-group>
          </b-col>
        </b-row>
        <b-card no-body>
          <b-table
            class="mb-0"
            ref="tblOrder"
            outlined
            striped
            hover
            small
            style="font-size:smaller;"
            :items="tblData.items"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            show-empty
          >
            <template v-slot:cell(index)="data">{{data.index + 1}}</template>
            <template v-slot:cell(total_kirim)="data">{{data.item.total_kirim | numFormat}}</template>

            <template v-slot:cell(empty)="scope">
              <h4>{{ scope.emptyText }}</h4>
            </template>
            <template v-slot:cell(emptyfiltered)="scope">
              <h4>{{ scope.emptyFilteredText }}</h4>
            </template>
          </b-table>
          <b-row>
            <b-col cols="5">
              <b-pagination
                align="left"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
            <b-col cols="4">
              <b-row>
                <div class="ml-4">
                  Showing
                  {{(tblData.page - 1) * tblData.limit + 1}}
                  to
                  {{tblData.page * tblData.limit}}
                  of
                  {{tblData.total}}
                  entries
                </div>
              </b-row>
            </b-col>
            <b-col cols="3" >
              <b-input-group>
                    <b-input-group-prepend><span class="input-group-text">Total Oplah</span></b-input-group-prepend>              
                    <b-form-input :value="tblData.totaloplah | numFormat('0,0.00')" readonly class="text-right font-weight-bold"></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">Eks.</span></b-input-group-prepend>              
              </b-input-group>
            </b-col>        
          </b-row>
        </b-card>
      <!-- <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="print()">
          <i class="fa fa-print"></i> Print
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close
        </b-button>
      </b-row> -->
    </b-card>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>


<script>
import Loading from "vue-loading-overlay";
import moment from "moment";
import koran_report from "../../apis/koran_report";
import crud from "../../apis/crud";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      tgl1: { required },
    }
  },
  data() {
    return {
      horizontal: true,
      saveEnabled: true,
      lkuKoranJurusanShow: false,
      model: {
        percetakan_name: '',
        percetakan_id: '',
        tgl1: '',
        tgl2: ''
      },
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        totaloplah:0,
        sortBy: 'percetakan_name',
        sortDesc: false
      },
      showReport: false,
      isLoading: false,
      reportUrl: null,
      percetakans: [],
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    maxIssuedDate() {
      return moment(new Date()).add(7,'days').format("YYYY-MM-DD");
    },
    tblFields() {
      const fields = [
        { key: "index", label: "No.", thStyle: "width:40px" },
        {
          key: "jurusan_code",
          label: "Kode Jurusan",
          sortable: true
        },
        {
          key: "jurusan_name",
          label: "Jurusan",
          sortable: true
        },
        {
          key: "ekspedisi_name",
          label: "Ekspedisi",
          sortable: true
        },
        {
          key: "jmldrop",
          label: "Jml.Drop",
          thStyle: "width:100px",
          tdClass:"text-right pr-4",
          sortable: true
        },
        {
          key: "percetakan_name",
          label: "Nama Percetakan",
          sortable: true
        },
        {
          key: "total_kirim",
          label: "Jumlah Cetak",
          thStyle: "width:100px",
          tdClass:"text-right pr-4",
          sortable: true
        }
      ];
      return fields;
    }
  },
  created: async function() {
    const  b = await 
      crud.list({
        tablename: "koranpercetakan",
        page: 1,
        limit: 1000,
        total: 0,
        sortBy: "percetakan_name",
        sortDesc: false
      });
    this.percetakans = b.reduce((newArr, item) => {
      newArr.push({ value: item.percetakan_id, text: item.percetakan_name });
      return newArr;
    }, [{value:'', text:'--- semua ---'}]);    
  },
  methods: {
    process: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.isLoading = true;
          this.model.tgl2 = this.model.tgl2 || this.model.tgl1;
          const data = JSON.parse(JSON.stringify(this.model));
          data.tgl1 = moment(this.model.tgl1).format('YYYY-MM-DD');
          data.tgl2 = moment(this.model.tgl2).format('YYYY-MM-DD');
          const list = await koran_report.ordercetak(data);
          this.tblData.items = list;
          this.tblData.total=list.length;
          if (list.length === 0) {
            this.isLoading = false;
            toastr.info("No data available. Please select other date.");
          } else {
            this.isLoading = false;
            toastr.success("Successfully");
            this.tblData.totaloplah = this.tblData.items.reduce((a, b) => a + b.total_kirim, 0);
          }
        } catch (error) {
          this.isLoading = false;
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
        }
      }
    },
    print: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.model.tgl2 = this.model.tgl2 || this.model.tgl1;
          const data = JSON.parse(JSON.stringify(this.model));
          data.tgl1 = moment(this.model.tgl1).format('YYYY-MM-DD');
          data.tgl2 = moment(this.model.tgl2).format('YYYY-MM-DD');
        this.reportUrl=null; this.showReport = true;
          this.reportUrl = await koran_report.ordercetakPrint(data);
          this.isLoading = false;
        } catch (error) {
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
        }
      }
    },
    exportxls: async function() {
      try {
          if (this.invalidFilter) {
            toastr.error("Please fill the form correctly.");
          } else {
                  this.model.tgl2 = this.model.tgl2 || this.model.tgl1;
                  const data = JSON.parse(JSON.stringify(this.model));
                  data.tgl1 = moment(this.model.tgl1).format('YYYY-MM-DD');
                  data.tgl2 = moment(this.model.tgl2).format('YYYY-MM-DD');

                  const response = await koran_report.ordercetakXls(data);
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `ordercetak.xlsx`);
                  document.body.appendChild(link);
                  link.click();
            }
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
    },

    close() {
      router.push({ name: "koran.home" });
    }
  }
};
</script>